import React, {useState} from "react";
import { useForm, SubmitHandler } from "react-hook-form";

import ContactHighlight from "../../components/ContactHighlight";
import Input from "../../components/Input";
import styles from "./styles.module.scss";
import "../../styles/App.scss";

import ContactImageNorm from "../../assets/norm.png";
import ContactImageJasper from "../../assets/jasper.png";

export interface IContactForm {
  name: string;
  email: string;
  phone: string;
  address: string;
  description: string;
}

enum SendStatus {
  Default,
  Sending,
  Success,
  Fail,
}

const Contact: React.FC = () => {
  const { register, errors, handleSubmit } = useForm<IContactForm>();
  const [sendStatus, setSendStatus] = useState<SendStatus>(SendStatus.Default);

  const onSubmit: SubmitHandler<IContactForm> = async (values) => {
    if (sendStatus != SendStatus.Default) { return }

    setSendStatus(SendStatus.Sending);

    const endpoint =
      "https://mcptaupo-c15cb.web.app/api/sendEmail"; // TODO: Move to config
    const response = await fetch(endpoint, {
      body: JSON.stringify(values),
      method: "POST",
    });

    const success = await response.ok;

    success ? setSendStatus(SendStatus.Success) : setSendStatus(SendStatus.Fail);
  };

  const submitButtonContent = () => {
    if (sendStatus === SendStatus.Sending) {
      return "Sending..."
    } else if (sendStatus === SendStatus.Success) {
      return "Email Sent. Thankyou!"
    } else if (sendStatus === SendStatus.Fail) {
      return "Error Sending Email"
    } else {
      return "Submit"
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.pagetitle}>
        <h1>Contact</h1>
      </div>
      <div className={styles.content}>
        <div className={styles["content-column"]}>
          <h2>Make an enquiry</h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Input
              name="name"
              label="Name"
              inputRef={register({ required: true })}
              error={errors.name}
            />
            <Input
              name="email"
              label="Email"
              type="email"
              inputRef={register({ required: true })}
              error={errors.email}
            />
            <Input
              name="phone"
              label="Phone"
              type="tel"
              inputRef={register({ required: true })}
              error={errors.phone}
            />
            <Input
              name="address"
              label="Address of enquiry"
              type="text"
              inputRef={register({ required: true })}
              error={errors.address}
            />
            <Input
              name="description"
              label="Anything else?"
              type="text"
              lines={4}
              inputRef={register()}
              error={errors.description}
            />
            <button className={styles["submit-button"]} type="submit">
              {submitButtonContent()}
            </button>
          </form>
        </div>
        <div className={styles["content-column"]}>
          <h2>Or contact us directly</h2>
          <div>
            <ContactHighlight
              name="Jasper May"
              email="jasper@mcptaupo.co.nz"
              phone="027 840 2222"
              uri={ContactImageJasper}
            />
            <ContactHighlight
              name="Norm May"
              email="norm@mcptaupo.co.nz"
              phone="027 511 1166"
              uri={ContactImageNorm}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
